<template>
  <div class="member-profile">
    <div class="vx-row mb-4">
      <div class="vx-col mb-6 w-full">
        <h4 class="text-primary">Profile</h4>
      </div>

      <div class="vx-col mb-4 w-full md:w-1/2">
        <vs-input
          v-model="profile.name"
          name="name"
          class="w-full"
          label="Name"
          color="dark"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm block mt-2"
          v-show="errors.has('name')"
        >
          {{ errors.first('name') }}
        </span>
      </div>

      <div class="vx-col mb-4 w-full md:w-1/2">
        <vs-input
          v-model="profile.baby_name"
          name="name"
          class="w-full"
          label="Child Name"
          color="dark"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm block mt-2"
          v-show="errors.has('baby_name')"
        >
          {{ errors.first('baby_name') }}
        </span>
      </div>

      <div class="vx-col mb-4 w-full md:w-1/2">
        <vs-input
          v-model="profile.contact"
          name="name"
          class="w-full"
          label="Contact"
          color="dark"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm block mt-2"
          v-show="errors.has('contact')"
        >
          {{ errors.first('contact') }}
        </span>
      </div>

      <div class="vx-col mb-4 w-full md:w-1/2">
        <vs-input
          v-model="profile.email"
          name="name"
          class="w-full"
          label="Email"
          color="dark"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm block mt-2"
          v-show="errors.has('email')"
        >
          {{ errors.first('email') }}
        </span>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full text-center">
        <vs-button
          class="mx-auto"
          icon-pack="feather"
          icon="icon-save"
          @click.prevent="updateProfile"
          :disabled="locked"
        >
          Update Profile
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import schemas from '@/utils/schemas'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'StoolTestProfile',
  props: {
    locked: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      schema: schemas.stoolTest(),
      profile: schemas.stoolTest()
    }
  },
  computed: {
    ...mapGetters('stoolQuestionnaire', {
      $profile: 'profile'
    })
  },
  methods: {
    ...mapActions('stoolQuestionnaire', ['update']),
    validate() {
      return this.$validator.validateAll()
    },
    save() {
      return this.update({
        id: this.profile.id,
        profile: this.profile
      })
    },
    async updateProfile() {
      const valid = await this.validate()

      if (valid) {
        this.$emit('locked', true)

        await Promise.all([this.save()])
          .then(() => {
            this.$vs.notify({
              title: 'Success',
              text: 'Profile has been updated',
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success'
            })
          })
          .catch(() => {
            this.$vs.notify({
              title: 'Error',
              text: 'Update fail',
              iconPack: 'feather',
              icon: 'icon-error',
              color: 'danger'
            })
          })
          .finally(() => {
            this.$emit('locked', false)
          })
      } else {
        this.$vs.notify({
          title: 'Error',
          text: 'Please complete this form',
          iconPack: 'feather',
          icon: 'icon-error',
          color: 'warning'
        })
      }
    }
  },

  mounted() {
    if (this.lodash.isObject(this.$profile)) {
      Object.assign(
        this.profile,
        this.lodash.pick(this.$profile, Object.keys(this.schema))
      )
    }
  },
  watch: {
    $profile(to) {
      Object.assign(
        this.profile,
        this.lodash.pick(to, Object.keys(this.schema))
      )
    }
  }
}
</script>
